export const UPGRADE_TOOLTIP_KEYS = {
    collectDemographics:
        "dialogs.channel_settings.upgrade_tooltips.collect_demographics",
    collectCustomData:
        "dialogs.channel_settings.upgrade_tooltips.collect_custom_data",
    customTextField:
        "dialogs.channel_settings.upgrade_tooltips.custom_text_field",
    allowDoubleVote:
        "dialogs.channel_settings.upgrade_tooltips.allow_double_vote",
    customQrColor: "dialogs.channel_settings.upgrade_tooltips.custom_qr_color",
    qrLogo: "dialogs.channel_settings.upgrade_tooltips.qr_logo",
    completionRedirect:
        "dialogs.channel_settings.upgrade_tooltips.completion_redirect",
} as const;

export const getCharCount = (
    watchValue?: string | null,
    fallbackValue?: string | null
): number => watchValue?.length ?? fallbackValue?.length ?? 0;

const normalizeReservedCustomVariableName = (value: string): string =>
    value.toLowerCase().replace(/[^a-z0-9]+/g, "");

type DemographicFieldMeta = {
    id: string;
    settingsId?: string;
};

const getDemographicFieldTranslationKey = (
    field: DemographicFieldMeta
): string => field.settingsId ?? field.id;

const getReservedDemographicCustomVariableNames = (
    fields: DemographicFieldMeta[],
    translate: (key: string) => string
): string[] =>
    fields.reduce<string[]>((reservedNames, field) => {
        const translationKey = getDemographicFieldTranslationKey(field);
        reservedNames.push(
            field.id,
            translate(`dialogs.channel_settings.demographics.${translationKey}`)
        );

        if (field.settingsId) {
            reservedNames.push(field.settingsId);
        }

        return reservedNames;
    }, []);

export const createReservedDemographicCustomVariableKeys = (
    fields: DemographicFieldMeta[],
    translate: (key: string) => string
): Set<string> =>
    new Set(
        getReservedDemographicCustomVariableNames(fields, translate).map(
            normalizeReservedCustomVariableName
        )
    );

export const normalizeCustomVariableLabel = (value: string): string =>
    normalizeReservedCustomVariableName(value);
